/* eslint-disable camelcase */
import axios from 'axios';
import { INDEXED_PRODUCT_PRICE_ENDPOINT, PRODUCT_PRICE_RECOMMENDATIONS_ENDPOINT } from '@dynameat/constants';

export const productPriceRecommendationsRequest = (prediction_period_guid) => axios.get(PRODUCT_PRICE_RECOMMENDATIONS_ENDPOINT(prediction_period_guid));
export const saveProductPriceRecommendationsRequest = (prediction_period_guid, product_price_recommendation_list) => axios.post(
  PRODUCT_PRICE_RECOMMENDATIONS_ENDPOINT(), { prediction_period_guid, product_price_recommendation_list }
);
export const indexedProductPriceRequest = (prediction_period_guid) => axios.get(INDEXED_PRODUCT_PRICE_ENDPOINT(prediction_period_guid));
